import { jsx as _jsx } from "react/jsx-runtime";
import { ElementOrIcon } from '@kubit/web-ui-components/elementOrIcon';
import { pickAriaProps } from '@kubit/web-ui-components/utils/aria';
import * as React from 'react';
import { ContainerStyled } from './badgeIcon.styled';
const BadgeIconStandAloneComponent = ({ ...props }, ref) => {
    const ariaProps = pickAriaProps(props);
    return (_jsx(ContainerStyled, { ...ariaProps, ref: ref, as: props.as, containerBackgroundColor: props.containerBackgroundColor, "data-testid": 'badge-icon', sizeStyles: props.sizeStyles, styles: props.styles, children: _jsx(ElementOrIcon, { customIconStyles: props.styles?.icon, ...props.icon }) }));
};
export const BadgeIconStandAlone = React.forwardRef(BadgeIconStandAloneComponent);
//# sourceMappingURL=badgeIconStandAlone.js.map